import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { Card, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";

// Actions de Redux
//import { editarPerfilAdministradorAction } from "../../redux/actions/administradorActions";

// Se llama a usuario solo para que no de error porque en esta versión no se permite editar el perfil
import { contrasenaUsuarioAction } from "../../redux/actions/usuarioActions";

import { Alert } from "../Utilidades";

const Perfil = () => {
  const dispatch = useDispatch();
  const [emailActual, setEmailActual] = useState();
  const [email, setEmail] = useState();
  const formikRef = useRef(null);

  // administrador a editar
  // const administradorEditar = useSelector(
  //   (state) => state.usuario
  // );

  const { user } = useSelector((state) => state.login);

  useEffect(() => {
    setEmailActual(user.usuario?.correo);
  }, [user]);

  const administradorSchema = Yup.object().shape({
    email: Yup.string().email("E-mail inválido").required("Requerido"),
  });

  // Acceder al state del store
  const { loading, error, errorMessage } = useSelector(
    (state) => state.administradores
  );

  // Confirmar si desea guardar los cambios
  const confirmarModificacionAdministrador = (administrador) => {
    // preguntar al usuario
    Swal.fire({
      title: "¿Está seguro que desea guardar los cambios del perfil?",
      text: "",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        // Se llama a usuario solo para que no de error porque en esta versión no se permite editar el perfil
        //dispatch(editarPerfilAdministradorAction(administrador));
        dispatch(contrasenaUsuarioAction());
      }
    });
  };

  return (
    <div className="col-md-6 mt-3">
      <Card>
        <Card.Header>
          <h3 className="card-title">Perfil</h3>
        </Card.Header>
        <Card.Body>
          <Formik
            innerRef={formikRef}
            initialValues={{ emailActual: emailActual, email: "" }}
            enableReinitialize={true}
            validationSchema={administradorSchema}
            onSubmit={(values, actions) => {
              confirmarModificacionAdministrador(values);
            }}
          >
            {({ errors, touched, values, handleChange }) => (
              <FormikForm>
                <Form.Group className="mb-2">
                  <Card.Text className="fw-bold">
                    Correo electrónico actual
                  </Card.Text>
                  <Form.Control
                    id="emailActual"
                    name="emailActual"
                    type="email"
                    value={emailActual}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Card.Text className="fw-bold">
                    Nuevo correo electrónico
                  </Card.Text>
                  <Form.Control
                    id="email"
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e) => {
                      handleChange(e);
                      setEmail(e.target.value);
                    }}
                    placeholder="Nuevo correo electrónico"
                    isInvalid={touched.email && !!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </FormikForm>
            )}
          </Formik>
        </Card.Body>
        <Card.Footer
          style={{ backgroundColor: "transparent", borderTop: "none" }}
        >
          <Button
            variant="danger"
            className="btn-sm"
            onClick={() => {
              formikRef.current?.submitForm();
            }}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Actualizando...
              </>
            ) : (
              "Actualizar"
            )}
          </Button>
          {!loading && error && (
            <Alert variant={"danger"} mensaje={errorMessage} />
          )}
        </Card.Footer>
      </Card>
    </div>
  );
};

export default Perfil;
